import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { VADProvider } from './components/layout/VADProvider';
import pkg from '../package.json';
import { PostHogProvider } from 'posthog-js/react';
import { useAppStore } from './hooks/useAppStore';
import { initChottoAppDetection } from './lib/browser';
import { installConsoleFilter } from './lib/consoleFilter';

console.log(`Version: v${pkg.version}`);
const VITE_PUBLIC_POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY || 'phc_w8qi7rgIrR9vOoBSLngNEE9FaEPYHwauG1KpXN7KdWA';
const VITE_PUBLIC_POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';

(async () => {
  installConsoleFilter();
  await initChottoAppDetection();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <PostHogProvider
        apiKey={VITE_PUBLIC_POSTHOG_KEY}
        options={{
          api_host: VITE_PUBLIC_POSTHOG_HOST,
          defaults: "2025-05-24",
          capture_exceptions: true,
          debug: import.meta.env.MODE === "development" && import.meta.env.VITE_POSTHOG_DEBUG !== "false",
          before_send: (event) => {
            if (!event || event.event === "$snapshot") {
              return event;
            }
            const roomId = useAppStore.getState().roomId;
            const user = useAppStore.getState().user;
            event.properties = {
              ...(event.properties || {}),
              roomId: roomId || "no_room",
              userId: user?.userId || "anonymous",
              appId: user?.appId || "no_app",
              platform: user?.platform || "unknown",
              provider: user?.provider || "unknown",
            };
            return event;
          },
        }}
      >
        <VADProvider>
          <App />
        </VADProvider>
      </PostHogProvider>
    </StrictMode>
  );
})();